import { ObservableArray, View } from "binder"
import { ProductImagesViewModel, singleItem } from "./productImages-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ProductImagesView extends View<ProductImagesViewModel>{
    GetViewUniqueId(): string {
        return "V-45922CFF-7CB8-42E3-8E95-C1E52DFD2178"
    }
    loadHtml(): string {
        let element = require('./productImages.html').default;
        let style = require('./productImages.less');
        return element;
    }
    constructor() {
       super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleItem>) { this._items = v; } public get items(): ObservableArray<singleItem> { return this._items;} private _items: ObservableArray<singleItem>;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

}
